// vim: set ts=2 sw=2 et tw=80 ft=javascript:
/**
 * Copyright (C) 2014, 2015, 2016 Minted Inc.
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:IDENTITY
 */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:community/constants': [],
  'templito:community': []
 })(this, function(m_module, Backbone, $, _) {

  "use strict";

  M.View = M.View || {};
  M.View.StorefrontTools = M.View.StorefrontTools || {};
  M.View.StorefrontTools.Page = M.View.StorefrontTools.Page || {};

  M.View.StorefrontTools.Page.DesignerAssetUpload = Backbone.View.extend({
    events: {
      'click .assetTextArea' : 'handleTextArea',
      'click .submitTextButton' : 'onSubmitText',
      'click .remindMeLaterButton' : 'renderRemindPopover',
      'click .doneButton': 'onDone'
    },

    initialize: function(options) {
      M.required(this.options.urlPaths);

      this.$el = $(this.el);
      if (!this.options) {
        this.options = options;
      }
      this.options.show_all_assets = this.options.using_welcome_mode ||
        this.options.is_store_tools;

      this._sanitize_strings();
    },

    render: function() {
      var templateHtml = M.Template.StorefrontTools.DesignerAssetUpload({
        options: this.options
      });

      this.$el.html(templateHtml);
      this.initializeTerms();
      this.renderEditableImages();
      this._instantiateDropdownAutoSuggest();
    },

    initializeTerms: function() {
      var termsModel = new M.Model.Community.UserTermsAgreement({
        nodeTitle: M.NODE_TITLES.TERMS_ARTIST_STORES,
        showReviewLaterButton: false
      });
      var termsView = new M.View.Community.UserTermsAgreement({
        model: termsModel,
        dialogTitle: 'please review the terms and conditions for your minted artist store'
      });
    },

    handleAssetUploadSuccess: function(evt, assetId) {
      var assetsStatus = {};
      this.doneButtonActive = false;
      assetsStatus[assetId] = true;
      // underscore every method used to check if every entry in
      // dictionary has True value
      // (_.identity method is like the function: f(x) = x)
      if (_.every(assetsStatus, _.identity)) {
        $('.doneButton').toggleClass('disabled', false);
        this.doneButtonActive = true;
      }
    },

    renderEditableImages: function() {
      this.submitTextButtonXhr = null;
      var that = this;
      this.assetsStatus = {};
      this.$el.find('.editableImageSimple').each(function(index) {
        // editable image parameters are stored as a comma separated
        //   string in each editableImageSimple element
        // display height/width and image height/width used to track
        //   how large image (10000x100000) needs to fit into small div
        //   so both #s required for display and image dimensions checking
        var $this = $(this);

        // contentStrList is a comma separated list of width and height values in
        // the template that defines image dimensions. Also includes the image url
        // and the asset id. Asset id is contentStrList[0].
        var contentStrList = $this.html().trim().split(',');
        var existingImgUrl = contentStrList[5];
        var assetId = contentStrList[0];
        var imgUrl = existingImgUrl ? existingImgUrl.trim() : '';
        var disableEdit = false;
        var disabledEditExplanationText = '';

        // Disabled editing the artist signture asset if it already has a file
        if (imgUrl !== '' && assetId == 'signature_img_artist') {
          disableEdit = true;
          disabledEditExplanationText = 'To avoid customer confusion ' +
            'in your artist identity, signature file cannot be changed. ' +
            'Please contact designers@minted.com with questions.';
        }

        var editableImageSimple = new M.View.EditableImageSimple({
          url: that.options.urlPaths['designer_asset_upload_image'],
          uid: that.options.uid,
          assetId: assetId,
          displayHeight: parseInt(contentStrList[1].trim(), 10),
          displayWidth: parseInt(contentStrList[2].trim(), 10),
          imageHeight: parseInt(contentStrList[3].trim(), 10),
          imageWidth: parseInt(contentStrList[4].trim(), 10),
          imgUrl: imgUrl, // can be undefined
          disableEdit: disableEdit,
          disabledEditExplanationText: disabledEditExplanationText
        });
        $this.html(editableImageSimple.render().el);
        $this.find('.editableImage').bind(
          'assetUploadSuccess', that.handleAssetUploadSuccess);
        // Mark whether asset is set or not
        // contentStrList[0] is the assetId string
        if (existingImgUrl) {
          that.assetsStatus[contentStrList[0]] = true;
        } else {
          that.assetsStatus[contentStrList[0]] = false;
        }
      });
    },

    onSubmitText: function(event) {
      var $submitButton = $(event.target),
          that = this;
      if (this.submitTextButtonXhr || $submitButton.hasClass('disabled')) {
        // ajax request already fired so exit
        return;
      }

      var $textArea = $submitButton.parent().parent().find('.assetTextArea');
      var $submitMsg = $submitButton.parent().parent().find('.submitMsg');

      var formData = {
        'asset_id': $textArea.attr('name'),
        'asset_text': $textArea.val()
      };

      this.submitTextButtonXhr = $.ajax({
        type: 'POST',
        url: this.options.urlPaths['designer_asset_upload_text'],
        data: JSON.stringify(formData),
        success: function(response) {
          var responseDict = $.parseJSON(response);
          if (responseDict['status'] == 'Success') {
            $submitButton.html('saved');
            $submitButton.toggleClass('disabled', true);
            that.handleAssetUploadSuccess(null, responseDict['asset_id']);
            $submitMsg.html('');
          } else {
            $submitMsg.html(responseDict['user_msg']);
          }
          that.submitTextButtonXhr = null;
        },
        error: function(jqXHR, response) {
          $submitMsg.html('update error, please try again');
          that.submitTextButtonXhr = null;
        }
      });
    },

    handleTextArea: function(event) {
      var $assetTextArea = $(event.target);
      var $submitTextButton = $assetTextArea.parent().parent().find('.submitTextButton');
      $submitTextButton.toggle(true);
      $submitTextButton.toggleClass('disabled', false);
      $submitTextButton.html('save changes');
    },

    renderRemindPopover: function() {
      M.Url.setWindowUrl(this.options.source_url);
    },

    onDone: function() {
      // Date of reminder already set by popup prompt before coming
      // to this page, so method doesn't need to do anything
      if (this.doneButtonActive && this.options.source_url) {
        window.location = this.options.source_url;
      } else {
        window.location.reload();
      }
    },

    _instantiateDropdownAutoSuggest: function() {
      var $designerLocation = this.$el.find('#designerLocation');
      new M.View.DropdownAutosuggest({
        el: $designerLocation,
        apiSrc: this.options.urlPaths['autosuggest_location'],
        query: '?query=',
        strictMatchCheck: false,
        submitClassCheck: '.js-formSubmit'
      });
    },

    _sanitize_strings: function() {
      var philosophy_text = this.options.designer.philosophy;
      var location_text = this.options.designer.location;

      if (philosophy_text) {
        philosophy_text = philosophy_text.trim();
      } else {
        philosophy_text = philosophy_text = '';
      }

      if (location_text) {
        location_text = location_text.trim();
      } else {
        location_text = '';
      }

      this.options.designer.philosophy = philosophy_text;
      this.options.designer.location = location_text;
    }

  });

  return { };

});
